import React from "react";
import { Button, Grid } from "@mui/material";
import FormGroup from "@mui/material/FormGroup";
import Checkbox from "@mui/material/Checkbox";
import appScreen1 from "../../../assets/Images/appScreen1.jpg";
import Zoom from "react-medium-image-zoom";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import CreateAlert from "./CreateAlert";
// End

function ApplicationScreen2() {
  // const label = { inputProps: { "aria-label": "Switch demo" } };

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");
  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);
  // End

  return (
    <>
      <div className="applicationScreensDiv">
        <div className="applicationScreensHead">Screen 2 - Alert Messages</div>
        <Grid container>
          <Grid item xs={12} md={6}>
            <div className="applicationScreenLeft">
              <FormControlLabel
                control={<Switch />}
                label="Access to All Data"
              />
              <div className="AddNewAlertBtOut">
                <Button
                  className="addSpotsBt"
                  onClick={handleClickOpen("body")}
                >
                  Add New Alert
                </Button>
              </div>
              <h5 className="selectFildHeading">Select modules & fields</h5>
              <FormGroup className="appliCheckOuter">
                <FormControlLabel
                  control={<Checkbox />}
                  label="Overdue Of Time"
                />
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  label="Unauthorised Entry"
                />
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  label="Parking Issue"
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Lorem Ipsum Dummy Text"
                />
              </FormGroup>

              <div className="appliBtOuter">
                <Button className="addBt">Give Access</Button>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div className="applicationScreenRight">
              <div className="appsScreenDiv">
                <Zoom>
                  <img
                    src={appScreen1}
                    alt="That Wanaka Tree, New Zealand by Laura Smetsers"
                  />
                </Zoom>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Create Alert</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <CreateAlert />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default ApplicationScreen2;
